import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";
import products from "@/data/products.json";

export default function ProductsList() {
  return (
    <>
      <SEO
        title="Ayak Sağlığı ve Dermokozmetik Ürünleri"
        description="Ankara Bağlıca MediEste merkezimizde önerilen profesyonel ayak sağlığı ürünleri, PediZone üreli kremler, temizleme köpükleri ve tırnak bakım serumları."
        path="/ayak-sagligi-urunleri"
      />
      <section className="pt-32 pb-6 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: "Ayak Sağlığı Ürünleri" }]} />
      </section>
      <section className="pb-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chip mb-4">Ayak Sağlığı Ürünleri</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#0B1B33] leading-[1.05] max-w-3xl mb-6 tracking-tight">Profesyonel Ayak ve Tırnak Bakım Ürünleri</h1>
        <p className="text-[#4B5A6E] max-w-3xl leading-relaxed text-base md:text-lg">
          Ankara Bağlıca podoloji ve bakım merkezimizde uzman podologlar eşliğinde önerilen; kuru ciltler, çatlak topuklar, tırnak batması ve mantar yatkınlığına karşı özel olarak formüle edilmiş profesyonel dermokozmetik ürün seçkimiz.
        </p>
      </section>
      <section className="pb-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {(() => {
            const valid = products.filter(p => p.slug !== "oje");
            const pedizoneItems = valid.filter(p => p.slug.includes("pedizone") || p.slug.includes("krem") || p.slug.includes("kopugu") || p.slug.includes("serum"));
            const otherItems = valid.filter(p => !pedizoneItems.includes(p));
            return [...pedizoneItems, ...otherItems];
          })().map((p) => (
            <Link
              key={p.slug}
              to={`/${p.slug}`}
              data-testid={`product-list-${p.slug}`}
              className="group medi-card p-4 md:p-6"
            >
              <div className="aspect-square bg-[#F5F7FA] mb-4 flex items-center justify-center overflow-hidden rounded-xl">
                {p.image ? (
                  <img src={`/${p.image}`} alt={p.title} loading="lazy" className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" />
                ) : null}
              </div>
              <h3 className="font-display text-base md:text-lg text-[#0B1B33] leading-tight mb-2 min-h-[3rem] font-medium">{p.title}</h3>
              <span className="inline-flex items-center gap-1 text-xs tracking-[0.15em] uppercase text-[#10B981] font-semibold">İncele <ArrowRight size={12} /></span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
